import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService";

const CredoJouralModal = ({ isOpen, onClose }) => {
  const [credo, setCredo] = useState("");

  const textAreaRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
        const textArea = textAreaRef.current;
        if (textArea) {
          textArea.focus();
          const length = textArea.value.length;
          textArea.setSelectionRange(length, length);
        }
      }
  }, [isOpen]);

  const saveCredo = async () => {

    if (!credo) {
      toastr.error("Please fill the credo");
      return;
    }

    const payload = {
      statement: credo,
      progress: 100,
    };

    try {
      const res = await apiServiceHandler("POST", "api/credo", payload);
      if (res.status) {
        toastr.success(res.message);
        onClose();
        setCredo("");
      }
    } catch (error) {
      console.log("Failed to save credo" + error);
    }
  };

  useEffect(() => {
    const fetchCredo = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/credo", {});
        if (res.status) {
          setCredo(res.data.statement);
        }
      } catch (error) {
        console.log("Failed to fetch data");
      }
    };
    fetchCredo();
  }, [isOpen]);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="next90-modal"
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: "none",
          backgroundColor: "#26262f",
          color: "#d1b794",
        }}
      >
        <Modal.Title style={{ fontWeight: "400" }}>CREDO</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#26262f" }}>
        <div
          className="edit-key"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <textarea
            type="text"
            className="credo-input"
            ref={textAreaRef}
            value={credo}
            onChange={(e) => setCredo(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          borderTop: "none",
          paddingTop: "1rem",
          backgroundColor: "#26262f",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            className="save-next90-btn"
            onClick={saveCredo}
          >
            <span className="driver-button__label">SAVE</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CredoJouralModal;
